import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
class Loadable {
  constructor(component) {
    var animationDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    var animationMinimumDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
    this._loadingState = false; // Private state
    this._loadingCounter = 0; // Counter for loading calls
    this._loadingTimer = null; // Timer for animation delay
    this._animationTimer = null; // Timer for minimum animation duration
    this._loadingStartTime = null; // Start time of loading animation
    this._originalAccessibilityState = new Map();
    this.component = component;
    this.animationDelay = animationDelay;
    this.animationMinimumDuration = animationMinimumDuration;
    if (!component) console.error('Loadable: No component provided', this);
  }
  isLoading() {
    return this._loadingState;
  }
  setLoading(isLoading) {
    var forceEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isLoading) {
      this._startLoading();
    } else {
      this._stopLoading(forceEnd);
    }
  }
  loading() {
    this.setLoading(true);
  }
  loaded() {
    var forceEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.setLoading(false, forceEnd);
  }
  _startLoading() {
    this._loadingCounter++;
    if (this._loadingState) return; // Prevent redundant calls

    this._loadingState = true;
    this._loadingStartTime = Date.now();
    this._triggerEvent('loading');
    clearTimeout(this._loadingTimer);
    this._loadingTimer = setTimeout(() => this._addLoadingClass(), this.animationDelay);
  }
  _stopLoading(forceEnd) {
    if (!forceEnd) {
      if (this._loadingCounter > 0) this._loadingCounter--;
      if (this._loadingCounter > 0) return; // Don't stop loading if counter is not zero
    }
    if (!this._loadingState) return; // Prevent redundant calls

    this._loadingState = false;
    var elapsedTime = Date.now() - this._loadingStartTime;
    clearTimeout(this._loadingTimer);
    var remainingTime = Math.max(this.animationMinimumDuration - elapsedTime, 0);
    clearTimeout(this._animationTimer);
    this._animationTimer = setTimeout(() => this._removeLoadingClass(), remainingTime);
  }
  _getFocusableElements() {
    return this.component.querySelectorAll('a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
  }
  _addLoadingClass() {
    this.component.classList.add('--loading');
    this.component.setAttribute('aria-busy', 'true');
    var focusables = this._getFocusableElements();
    focusables.forEach(el => {
      this._originalAccessibilityState.set(el, {
        disabled: el.disabled,
        tabindex: el.getAttribute('tabindex'),
        ariaHidden: el.getAttribute('aria-hidden')
      });
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
      el.disabled = true;
    });
  }
  _removeLoadingClass() {
    this.component.classList.remove('--loading');
    this.component.removeAttribute('aria-busy');
    this._originalAccessibilityState.forEach((original, el) => {
      if (original.disabled === false) el.disabled = false;
      if (original.tabindex !== null) {
        el.setAttribute('tabindex', original.tabindex);
      } else {
        el.removeAttribute('tabindex');
      }
      if (original.ariaHidden !== null) {
        el.setAttribute('aria-hidden', original.ariaHidden);
      } else {
        el.removeAttribute('aria-hidden');
      }
    });
    this._originalAccessibilityState.clear();
    this._triggerEvent('loaded');
  }
  _triggerEvent(eventName) {
    if (this.namespace) {
      iamotaEventHandler.trigger("".concat(this.namespace, ":").concat(eventName), {
        component: this
      }, {
        context: this
      });
    }
  }
}
export default Loadable;